import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons';

import FilterButton from 'components/search_sidebar/filter_button';
import Tag from 'components/tags/tag';

import CompanyGroupFilter from '../companies/company_group_filter';
import PersonGroupFilter from '../people/person_group_filter';
import RelationshipFilterGroup from './relationship_filter_group';

import {
  clearFilters,
  clearFiltersIfEmpty,
  setTags,
  toggleRole
} from "../store/actions/query";

import { toggleMobileFilters } from "../store/actions/ui";

import { delayRetrieveRecords } from "../store/actions/search";

export class MobileContactFilters extends React.Component {
  static propTypes = {
    availableTags: PropTypes.array.isRequired,
    canAccessCrm: PropTypes.bool.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    companyCount: PropTypes.number,
    companyGroups: PropTypes.array,
    contactRoles: PropTypes.array.isRequired,
    currentTags: PropTypes.array.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    isCompany: PropTypes.bool,
    peopleCount: PropTypes.number,
    peopleGroups: PropTypes.array,
    selectedCompanyGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    selectedPeopleGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    selectedRoles: PropTypes.array.isRequired,
    setTags: PropTypes.func.isRequired,
    toggleRole: PropTypes.func.isRequired,
    totalUngroupedCompanyCount: PropTypes.number,
    totalUngroupedPeopleCount: PropTypes.number,

    onChangeSearchText: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onCloseFilters: PropTypes.func.isRequired
  };

  handleClearFilters = () => {
    const { onClearFilters, delayRetrieveRecords } = this.props;
    onClearFilters();
    delayRetrieveRecords();
  };

  handleClearFiltersIfEmpty = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleAddTag = (tag) => {
    const { currentTags } = this.props;
    currentTags.push(tag);
    this.handleTagChange(currentTags);
  };

  handleRemoveTag = (tag) => {
    const { currentTags } = this.props;
    const newTags = currentTags.filter(t => t !== tag);
    this.handleTagChange(newTags);
  };

  handleTagChange = (tags) => {
    this.props.setTags(tags);
    this.handleClearFiltersIfEmpty();
  };

  handleRoleChange = (e) => {
    this.props.toggleRole(e.target.value, e.target.checked);
    this.handleClearFiltersIfEmpty();
  };

  get selectedGroups() {
    const {
      isCompany,
      selectedPeopleGroupIds,
      selectedCompanyGroupIds,
      companyGroups,
      peopleGroups,
      totalUngroupedCompanyCount,
      totalUngroupedPeopleCount
    } = this.props;

    if (isCompany) {
      return this.findSelectedGroups(selectedCompanyGroupIds, companyGroups, totalUngroupedCompanyCount);
    } else {
      return this.findSelectedGroups(selectedPeopleGroupIds, peopleGroups, totalUngroupedPeopleCount);
    }
  }

  findSelectedGroups(selectedGroupIds, groups, ungroupedCount) {
    if (selectedGroupIds[0] === 'ungrouped') {
      return [{ id: 'ungrouped', name: 'Ungrouped', count: ungroupedCount }];
    } else {
      return groups.filter(group => selectedGroupIds.includes(group.id));
    }
  }

  get groupFilterLabel() {
    const selectedGroups = this.selectedGroups;

    if (selectedGroups.length === 0) {
      return this.props.isCompany ? 'All Companies' : 'All Contacts';
    } else if (selectedGroups.length === 1) {
      return selectedGroups[0].name;
    } else {
      return `${selectedGroups.length} Groups`;
    }
  }

  get groupFilterCount() {
    const selectedGroups = this.selectedGroups;

    if (selectedGroups.length === 0) {
      if (this.props.isCompany) {
        return this.props.companyCount;
      } else {
        return this.props.peopleCount;
      }
    } else if (selectedGroups[0].id === 'ungrouped') {
      return selectedGroups[0].count;
    } else {
      const key = this.props.isCompany ? 'companyCount' : 'personCount';
      return selectedGroups.reduce((count, group) => count + group[key], 0);
    }
  }

  render() {
    const { canAccessCrm, companyGroups, isCompany, peopleGroups, onCloseFilters } = this.props;
    const displayGroups = isCompany ? companyGroups.length > 0 : peopleGroups.length > 0;

    return (
      <div>
        <button className="btn close-filters-btn btn-default" onClick={this.handleClearFilters}>Clear Filters</button>
        {canAccessCrm && displayGroups && this.renderGroupButton()}
        {this.renderRelationshipFilters()}
        {this.renderTagsFilter()}
        <button className="btn btn-dark top-buffer-sm" onClick={onCloseFilters}>View Contacts</button>
      </div>
    );
  }

  renderGroupFilterLabel() {
    let count;
    if (this.selectedGroups.length <= 1) {
      count = (
        <span className="left-buffer-sm">
          ({this.groupFilterCount})
        </span>
      );
    }

    return (
      <React.Fragment>
        <FontAwesomeIcon
          className="right-buffer-md folder-icon"
          icon={faFolderOpen}
        />
        <span className="group-text">
          {this.groupFilterLabel}
          {count}
        </span>
      </React.Fragment>
    );
  }

  renderGroupButton() {
    return (
      <React.Fragment>
        <h4>Groups</h4>
        <FilterButton
          filtersApplied={false}
          label={this.renderGroupFilterLabel()}
          name="groups"
        >
          {this.props.isCompany ? <CompanyGroupFilter showLabel={false} /> : <PersonGroupFilter showLabel={false} />}
        </FilterButton>
      </React.Fragment>
    );
  }

  renderRelationshipFilters() {
    const { contactRoles, selectedRoles } = this.props;

    return (
      <React.Fragment>
        <h4 className="top-buffer-sm bottom-buffer-xs">Contact Type</h4>
        <RelationshipFilterGroup
          roles={contactRoles}
          selected={selectedRoles}
          showLabel={false}
          onChange={this.handleRoleChange}
        />
      </React.Fragment>
    );
  }
  renderTagsFilter() {
    const { availableTags, currentTags } = this.props;
    const tagList = [];
    availableTags.forEach((availableTag) => {
      if (currentTags.findIndex(tag => tag === availableTag) >= 0) {
        tagList.push(
          <div
            className="clickable d-inline-block active-tag"
            key={availableTag}
            onClick={() => this.handleRemoveTag(availableTag)}
          >
            <Tag>{availableTag}</Tag>
          </div>
        );
      } else {
        tagList.push(
          <div
            className="clickable d-inline-block inactive-tag"
            key={availableTag}
            onClick={() => this.handleAddTag(availableTag)}
          >
            <Tag>{availableTag}</Tag>
          </div>
        );
      }
    });

    if (tagList.length > 0) {
      return (
        <React.Fragment>
          <h4>Tags</h4>
          {tagList}
        </React.Fragment>
      );
    }
  }
}


const mapStateToProps = state => ({
  availableTags: state.static.tags,
  canAccessCrm: state.ui.canAccessCrm,
  contactRoles: state.static.contactRoles,
  companyCount: state.search.meta.companies.databaseCount,
  companyGroups: state.companies.groups,
  peopleCount: state.search.meta.people.databaseCount,
  peopleGroups: state.people.groups,
  searchText: state.query.searchText,
  selectedCompanyGroupIds: state.query.companyGroupIds,
  selectedPeopleGroupIds: state.query.peopleGroupIds,
  selectedRoles: state.query.roles,
  currentTags: state.query.tags,
  tagsPaths: state.paths.tags,
  totalUngroupedCompanyCount: state.search.meta.companies.totalUngroupedCount,
  totalUngroupedPeopleCount: state.search.meta.people.totalUngroupedCount
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  setTags,
  toggleRole,

  onClearFilters: clearFilters,
  onCloseFilters: toggleMobileFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileContactFilters);
